export function getItemLibraryProps() {
  return {
    locationId: window.data.design.locationId,
    memberId: window.data.member.id,
  };
}
